import type {
  CredentialsConfig,
  NewCredential,
} from 'src/types/data-integration';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApi from 'src/utils/redux-api';
import {thunkify as flow} from 'src/utils/thunks';
import {key, fetching} from 'src/utils/redux';


export const GET_CREDENTIALS_META = 'credentials-meta/receive';
export const GET_CREDENTIALS = 'credentials/receive';

type ReceiveCredentialsMetaData = {
  type: typeof GET_CREDENTIALS_META;
  payload: CredentialsConfig;
};

type ReceiveCredentials = {
  type: typeof GET_CREDENTIALS;
  payload: CredentialsConfig;
};

export type CredentialsActions =
  | ReceiveCredentialsMetaData
  | ReceiveCredentials;

export const receiveCredentialsMeta = (
  payload: CredentialsConfig,
): ReceiveCredentialsMetaData => ({
  type: GET_CREDENTIALS_META,
  payload,
});
export const receiveCredentials = (
  payload: CredentialsConfig,
): ReceiveCredentials => ({
  type: GET_CREDENTIALS,
  payload,
});

// @ts-expect-error - TS2322 - Type '() => (dispatch: Dispatch) => Promise<unknown>' is not assignable to type '() => ThunkAction<void>'.
export const getCredentialsMeta: () => ThunkAction<void> = flow(
  key(() => 'credentials_meta'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(reduxApi.get(`credentials/meta`));
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'CredentialsConfig'.
    dispatch(receiveCredentialsMeta(res));
    return res;
  } catch (err: any) {
    throw err;
  }
});

// @ts-expect-error - TS2322 - Type '() => (dispatch: Dispatch) => Promise<unknown>' is not assignable to type '() => ThunkAction<void>'.
export const getCredentials: () => ThunkAction<void> = flow(
  key(() => 'credentials'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(
      reduxApi.get(`credentials`, {unmaskSecrets: true}),
    );
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'CredentialsConfig'.
    dispatch(receiveCredentials(res));
    return res;
  } catch (err: any) {
    throw err;
  }
});

// @ts-expect-error - TS2322 - Type '(page: number, page_size: number) => (dispatch: Dispatch) => Promise<unknown>' is not assignable to type '(page: number, page_size: number) => ThunkAction<void>'.
export const getActivityLog: (
  page: number,
  page_size: number,
) => ThunkAction<void> = flow(
  key(() => 'activityLog'),
  fetching(),
)((page: number, page_size: number) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(
      reduxApi.get(`credentials/audit-log?page=${page}&page_size=${page_size}`),
    );
    return res;
  } catch (err: any) {
    throw err;
  }
});

// @ts-expect-error - TS2322 - Type '(credentialData: NewCredential) => (dispatch: Dispatch) => Promise<unknown>' is not assignable to type '(credentialData: NewCredential) => ThunkAction<void>'.
export const updateCredentials: (
  credentialData: NewCredential,
) => ThunkAction<void> = flow(
  key(() => 'credentials_update'),
  fetching(),
)((credentialData) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(reduxApi.post(`credentials`, credentialData));
    return res;
  } catch (err: any) {
    throw err;
  }
});

// @ts-expect-error - TS2322 - Type '(credentialData: NewCredential) => (dispatch: Dispatch) => Promise<unknown>' is not assignable to type '(credentialData: NewCredential) => ThunkAction<void>'.
export const validCredentials: (
  credentialData: NewCredential,
) => ThunkAction<void> = flow(
  key(() => 'credentials_validate'),
  fetching(),
)((credentialData) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(
      reduxApi.post(`credentials/validate`, credentialData),
    );
    return res;
  } catch (err: any) {
    throw err;
  }
});
